import React, { useState } from 'react'
import { useGetUserProfileQuery } from '../../../store/Reducer/user-profile'
import PersonalInfo from './personal-info'
import Security from './security'
import LoadingScreen from '../../../components/loaders/loading-screen';
import { useTranslation } from 'react-i18next';

export default function UserProfileView() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('personal');

    const { data: profileData, isLoading } = useGetUserProfileQuery();
    console.log(profileData);


    if (isLoading) return <LoadingScreen />

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-50 py-6 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Profile Header */}
                <div className="mb-4 text-start">
                    <h1 className="mt-4 text-3xl font-bold text-gray-900">{t("user_profile_title")}</h1>
                    <p className="text-gray-500">{t("user_profile_desc")}</p>
                </div>

                {/* Tabs */}
                <div className="mb-6 border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8">
                        <button
                            onClick={() => setActiveTab('personal')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'personal'
                                ? 'border-blue-500 text-blue-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            {t("user_profile_tab_personal_info")}
                        </button>
                        <button
                            onClick={() => setActiveTab('security')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'security'
                                ? 'border-blue-500 text-blue-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            {t("user_profile_tab_security")}
                        </button>
                    </nav>
                </div>

                {/* Main Content */}
                {activeTab === 'personal' && (
                    <PersonalInfo profileData={profileData} />
                )}
                {activeTab === 'security' && (
                    <Security />
                )}
            </div>
        </div>
    )
}